// extracted by mini-css-extract-plugin
export default {"active":"Navbar_active__tWrF-","inactive":"Navbar_inactive__je5hy","mobileActive":"Navbar_mobileActive__CZm9T"};